import * as React from 'react';
import './Toggle.scss';


export class Toggle extends React.Component<{
    checked: boolean,
    onClick: () => void
    label?: string,
}> {
    uuid = 'toggle_' + Date.now() + Math.random() * 100;

    render() {
        return (
            <div className='onoffswitch'>
                <input type='checkbox' className='onoffswitch-checkbox' id={this.uuid}
                       checked={this.props.checked}
                       onChange={this.props.onClick}
                />
                <label className='onoffswitch-label' htmlFor={this.uuid}></label>
                {this.props.label && <span>{this.props.label}</span>}
            </div>
        );
    }
}
